<template>
    <main class="main-content">
        <router-view></router-view>
    </main>
</template>
<script>
export default {
    name: "MainContent"
}
</script>
<style scoped>
.main-content {
  flex: 1;
  padding: 1rem;
  overflow-y: auto;
  background-color: #f5f5f5;
}
</style>
